import React, { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';

interface SaveResultsDialogProps {
  open: boolean;
  onClose: () => void;
  totalItemsMatched: number;
}

const SaveResultsDialog: FC<SaveResultsDialogProps> = ({
  open,
  onClose,
  totalItemsMatched,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, fontSize: '1.5rem' }}>
        Rules Saved
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          {'Your rules have been saved and a background job has been queued to apply them to '}
          <strong>{totalItemsMatched}</strong>
          {` matching catalog${totalItemsMatched === 1 ? ' record' : ' records'}.`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: '#c1440e',
            '&:hover': { bgcolor: '#a53b0b' },
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveResultsDialog;
